//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["start_rcp","end_rcp","segment","sbend_type","bend_radius"],"CreateCornerBySegBendRadius",{R_:{sbend:"Routing.SBendCorner"}},5,0],[["start_rcp","end_rcp","segment","sbend_type","bend_ratio"],"CreateCornerBySegBendRatio",{R_:{sbend:"Routing.SBendCorner"}},5,0],[["start_rcp","end_rcp","bend_ratio","sbend_type"],"CreateCornerByBendRatio",{R_:{sbend:"Routing.SBendCorner"}},4,0],[["start_rcp","end_rcp","bend_radius","sbend_type"],"CreateCornerByBendRadius",{R_:{sbend:"Routing.SBendCorner"}},4,0],[["rcp"],"IsRcpAssociatedToSBend",{R_:{is_sbend_rcp:''}},1,0],[["segment"],"GetSBendAssociatedToSegment",{R_:{corner:"Routing.SBendCorner"}},1,0],[["rcp","num_sbends"],"GetSBendAssociatedToRcp",{R_:{sbends:"Routing.SBendCorner[]"}},1,0],[["rcp"],"GetRcpSBendRadius",{R_:{bend_radius:''}},1,0],[["segment"],"GetSegmentSBendRadius",{R_:{bend_radius:''}},1,0],[["start_pnt","end_pnt","line_vec1","line_vec2","radius","sbend_type","bend_curve"],"ComputeSBend",{R_:{is_sbend:''}},6,0],[["start_pnt","end_pnt","line_vec1","line_vec2","radius","sbend_type","extension_pt1","extension_pt2","arc1_start_pt","arc1_end_pt","arc2_start_pt","arc2_end_pt"],"ComputeSBendData",{R_:{is_sbend:''}},6,0],[["start_rcp","end_rcp","bend_radius","sbend_type","sbend"],"EditCornerByBendRadius",{},5,0],[["start_rcp","end_rcp","bend_ratio","sbend_type","sbend"],"EditCornerByBendRatio",{},5,0]],[]];
SPLM.Routing.SBendCornerCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.SBendCornerCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;